module.exports = __webpack_public_path__ + "static/media/talao.3535e263.png";